import React, { useContext } from 'react';
import { Jumbotron, Container } from 'reactstrap';
import { Utilities } from '@utils';
import styles from './header-information.module.scss';
import { IHeaderInformation } from '@interfaces/ux/header-information.interface';
import StoreCtx from '../../../context/store-context';
import { HeaderInformationPresenter } from '../../../presenters/ux/header-information.presenter';
import Loader from '../../ui/aea-fade-loader/Loader';

const { StoreContext } = StoreCtx;

const HeaderInformation: React.FC<IHeaderInformation> = (props: IHeaderInformation) => {

    const view: IHeaderInformation = {
        store: useContext(StoreContext),
        data: props.data
    }

    const presenter = new HeaderInformationPresenter(view);

    return (
        <Jumbotron className={styles.Jumbotron} style={{position: 'relative'}}>
            <Loader loading={!props.data} />
            <Container fluid >
                <div className={styles.Container} style={{minHeight: '100px'}}>
                    {props?.data?.map((value: any, index: number) => {
                        if (!Utilities.isNullEmptyObject(value.value)) {
                            return <label key={index}><strong>{presenter.getFieldName(value.label)}:</strong> {value.value}</label>;
                        }
                    })}
                </div> 
            </Container>
        </Jumbotron>
    )
}
export default HeaderInformation;